// extracted by mini-css-extract-plugin
module.exports = {"root":"reveal-module--root--WlJLv","reveal":"reveal-module--reveal--4MRCk"};